import { FC, useCallback, useContext, useMemo } from 'react';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailCount: FC<{ id: number }> = ({ id }) => {
  const { redeliveryDetails, setRedeliveryDetails } = useContext(RedeliveryContext);

  const redeliveryDetail = useMemo(() => redeliveryDetails.get(id), [id, redeliveryDetails]);
  const setRedeliveryDetailCount = useCallback(
    (count: number) => setRedeliveryDetails(prevState => new Map(prevState).set(id, { ...prevState.get(id)!, count })),
    [id, setRedeliveryDetails]
  );

  return (
    <div className="text-field">
      <input
        className="w-100"
        data-cy="redelivery-count-button"
        type="number"
        onChange={e => setRedeliveryDetailCount(Number(e.target.value))}
        required
        min={Math.max(1, redeliveryDetail?.unitCount ?? 0)}
        value={redeliveryDetail?.count ?? ''}
      />
      <label>QUANTITY *</label>
    </div>
  );
};

export default RedeliveryDetailCount;
